import React from 'react';
import QrsTabs from './QrsTabs/QrsTabs';

const PqrsTables = () => {
  return <QrsTabs />;
};

export default PqrsTables;
